// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-10Iq8";
var _3 = "label-3rvTR";
var _4 = "checkedIcon-3YA9k";
var _5 = "dot-1WpV1";
var _6 = "active-1l11W";
var _7 = "disabled-3M9p8";
export { _1 as "__esModule", _2 as "root", _3 as "label", _4 as "checkedIcon", _5 as "dot", _6 as "active", _7 as "disabled" }
export default { "__esModule": _1, "root": _2, "label": _3, "checkedIcon": _4, "dot": _5, "active": _6, "disabled": _7 }
